import styled from "styled-components";
import Box from "@mui/material/Box";

export const BoxCustom = styled(Box)`
  min-height: calc(100vh - 250px);
  margin: 40px;
`;

export const BoxCustomFoot = styled(Box)`
  min-height: calc(100vh - 250px);
  margin: 20px;
`;
export const FeedbackTitle = styled.h2`
  color: var(--primary);
  margin-bottom: 1.063rem;
  font-size: 1.125rem;
`;
